import { EChatListSection, EChatListTrigger, TChatListSource } from './types';

/**
 * Собирает источник запроса списка чатов из раздела и вызвавшего действия
 */
export function getChatListSource(section: EChatListSection, trigger: EChatListTrigger): TChatListSource {
  return `chatList:${section}:${trigger}`;
}
